<template>
  <ul class="quickfacts">
    <li
      v-for="(quickfact) in quickfacts"
      :key="quickfact.type"
      class="quickfacts__item"
      :class="`quickfacts__item--icon-${quickfact.type}`"
    >
      <span
        class="quickfacts__label"
        v-html="quickfact.name"
      />
      <span class="quickfacts__value">
        <template
          v-if="useLinks || splitValues"
        >
          <component
            v-for="(valueAndLink, valueAndLinkIndex) in quickfact.valuesAndLinks"
            :key="valueAndLinkIndex"
            :is="getTagFor(valueAndLink.second)"
            class="quickfacts__value-item"
            :class="{'quickfacts__value-item--linked': valueAndLink.second}"
            :href="valueAndLink.second || null"
            role="button"
            tabindex="0"
            @click="handleClick(valueAndLink.second)"
            @keydown.enter.space.prevent="handleClick(valueAndLink.second)"
            v-html="valueHtml(valueAndLink.first)"
          />
        </template>
        <template
          v-else
        >
          {{ valueText(quickfact.valuesAndLinks) }}
        </template>
      </span>
    </li>
  </ul>
</template>

<script lang="ts">
  import {Vue, Options, Prop} from 'vue-property-decorator';
  import Quickfact from '../../types/Quickfact';
  import type Pair from '../../types/Pair';

  @Options({
    name: 'quickfacts'
  })
  export default class Quickfacts extends Vue {
    @Prop({required: true, type: Array})
    readonly quickfacts: Array<Quickfact>

    @Prop({default: false})
    readonly splitValues: boolean;

    @Prop({default: true})
    readonly useLinks: boolean;

    getTagFor(value: string): string {
      let result = 'div';
      if (value && !this.isGeneratedFilterCategoryLink(value)) {
        result = 'a';
      }
      return result;
    }

    isGeneratedFilterCategoryLink(linkString) {
      return linkString.indexOf('?filter') >= 0;
    }

    handleClick(link) {
      if (link && this.isGeneratedFilterCategoryLink(link)) {
        window.location = link;
      }
    }

    valueHtml(value) {
      if (this.splitValues) {
        const splitValue = value.split(', ').map(element => {
          return `<span>${element}</span>`;
        });
        return splitValue.join(', ');
      }
      return value;
    }

    valueText(valuesAndLinks: Pair[]) {
      return valuesAndLinks
        .map(valueAndLink => valueAndLink.first)
        .join(', ');
    }
  }
</script>
